export const WORK_SHIFTS = {
  MORNING: 1,
  AFTERNOON: 2,
  NIGHT: 3
};
